import { useMediaQuery } from 'react-responsive'
// const isDesktopOrLaptop = useMediaQuery({
//     query: '(min-width: 1224px)'
//   })
//   const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
//   const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
//   const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
//   const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })

// export const isDesktopOrLaptop = {
//     query: '(min-width: 1224px)'
// }

// export const isTabletOrMobile = {
//    query: '(max-width: 1224px)'
// }

// export const isPortrait = {
//     query: '(orientation: portrait)'
// }

// export const isRetina = {
//     query: '(min-resolution: 2dppx)'
// }
export const useMobileMediaQuery = () =>
  useMediaQuery({ query: '(min-width: 1280px)' })


export const useDesktopMediaQuery = () =>
  useMediaQuery({ query: '(min-width: 1280px)' })

export const useTabletAndBelowMediaQuery = () =>
  useMediaQuery({ query: '(max-width: 1279px)' })

export const Desktop = ({ children }) => {
  const isDesktop = useDesktopMediaQuery()

  return isDesktop ? children : null
}

export const TabletAndBelow = ({ children }) => {
  const isTabletAndBelow = useTabletAndBelowMediaQuery()

  return isTabletAndBelow ? children : null
}